// extracted by mini-css-extract-plugin
export default {"serviceName":"service_serviceName__wu9cf","serviceLink":"service_serviceLink__VLbL2","servicesDiv":"service_servicesDiv__qLW1G"};